<div class="modal-content" *ngIf="IsLoadData">
    <div
        class="modal-header"
        style="
            background-color: #569c5b;
            color: #fff;
            cursor: all-scroll;
            padding: 0.2rem 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        "
    >
        <h4 class="modal-title pl-3">
            Détails
            <strong
                class="cursor-pointer text-center"
                (click)="copyTransaction(transaction?.transaction)"
            >
                [{{ transaction?.transaction }}]
            </strong>
        </h4>
        <button
            type="button"
            class="close"
            (click)="handleCloseModal()"
            aria-label="Close"
            style="margin-left: auto"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-lg-2" style="border-right: 1px solid #d8d8d8">
                <div>
                    <fieldset>
                        <legend>
                            <strong>Emission</strong>
                        </legend>
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Matricule&nbsp;:&nbsp;</strong>
                                    {{
                                        detailTransaction?.demandeur_matricule ??
                                            'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Nom complet&nbsp;:&nbsp;</strong>
                                    {{
                                        detailTransaction?.demandeur_nom ??
                                            'N/A'
                                    }}
                                    {{
                                        detailTransaction?.demandeur_prenoms ??
                                            'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Contact&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.demandeur_contacts ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Email&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.demandeur_email ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Date&nbsp;:&nbsp;</strong
                                    >{{
                                        transaction?.created_at ?? 'N/A'
                                    }}</span
                                >
                            </div>
                        </div>
                    </fieldset>
                              
                </div>
                <div>
                    <fieldset>
                        <legend>
                            <strong>Homologation</strong>
                        </legend>
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Matricule&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.intervenant
                                            ?.matricule ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Nom Complet&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.intervenant?.nom ??
                                            'N/A'
                                    }}
                                    {{
                                        detailTransaction?.intervenant
                                            ?.prenoms ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Contact&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.intervenant
                                            ?.contacts ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Email&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.intervenant?.email ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Date&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.rapport
                                            ?.date_traitement ??
                                            detailTransaction?.rapport
                                                ?.date_acquittement
                                    }}</span
                                >
                            </div>
                        </div>
                    </fieldset>
                              
                </div>
                <div>
                    <fieldset>
                        <legend>
                            <strong>Finalisation</strong>
                        </legend>
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Matricule&nbsp;:&nbsp;</strong>
                                    {{
                                        detailTransaction?.finalisateur
                                            ?.matricule ?? 'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Nom complet&nbsp;:&nbsp;</strong>
                                    {{
                                        detailTransaction?.finalisateur?.nom ??
                                            'N/A'
                                    }}
                                    {{
                                        detailTransaction?.finalisateur
                                            ?.prenoms ?? 'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30">
                                    <sstrong>Contact&nbsp;:&nbsp;</sstrong>
                                    {{
                                        detailTransaction?.finalisateur
                                            ?.contacts ?? 'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Email&nbsp;:&nbsp;</strong>
                                    {{
                                        detailTransaction?.finalisateur
                                            ?.email ?? 'N/A'
                                    }}
                                </span>
                            </div>
                            <div>
                                <span class="mb-0 fs__30">
                                    <strong>Date&nbsp;:&nbsp;</strong>
                                    {{ detailTransaction?.finalise_a ?? 'N/A' }}
                                </span>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="col-lg-10">
                <div
                    [ngClass]="
                        OnGetRapportCodeStyle(detailTransaction?.rapport?.code)
                    "
                    role="alert"
                    style="display: flex; justify-content: space-between"
                >
                    <div>
                        <strong class="wrapper-header">
                            {{ 'RECEPTION' | translate }} :
                            {{
                                [
                                    detailTransaction?.rapport
                                        ?.date_acquittement
                                ] ?? '-- : --'
                            }}</strong
                        >
                    </div>
                    <div>
                        <strong class="wrapper-header"
                            >Traitement :
                            {{
                                detailTransaction?.rapport?.statut_traitement ??
                                    'N/A'
                            }}
                            [{{
                                detailTransaction?.rapport?.date_traitement ??
                                    '-- : --'
                            }}]</strong
                        >
                    </div>
                    <div>
                        <strong class="wrapper-header">
                            Clôture :
                            {{
                                [detailTransaction?.rapport?.date_cloture] ??
                                    '-- : --'
                            }}</strong
                        >
                    </div>
                </div>
                <div>
                    <div class="d-flex justify-content-between">
                        <div>
                            <h4
                                *ngIf="detailTransaction?.rapport"
                                class="wrapper-header"
                            >
                                <strong
                                    >{{
                                        getTitleFormOuvrage(
                                            detailTransaction?.operation
                                        )
                                    }}
                                    <span
                                        style="
                                            color: #549b3d;
                                            font-weight: bold;
                                        "
                                    >
                                        <span *ngIf="IsContentSim()">
                                            {{
                                                detailTransaction?.point_emplacement ??
                                                    'N/A'
                                            }}
                                            [{{
                                                detailTransaction?.msisdn ??
                                                    'N/A'
                                            }}] </span
                                        >&nbsp;
                                        <span
                                            *ngIf="IsProvisionningTransaction()"
                                        >
                                            {{
                                                detailTransaction?.reference ??
                                                    'N/A'
                                            }}
                                            [{{
                                                detailTransaction?.rapport
                                                    ?.code ?? 'N/A'
                                            }}] </span
                                        >&nbsp;
                                        <span *ngIf="IsAchatTransaction()">
                                            {{
                                                detailTransaction?.numero_commande ??
                                                    'N/A'
                                            }}
                                            [{{
                                                detailTransaction?.rapport
                                                    ?.code ?? 'N/A'
                                            }}] </span
                                        >&nbsp;
                                        <span
                                            *ngIf="
                                                detailTransaction?.rapport
                                                    ?.identifiant
                                            "
                                            >[{{
                                                detailTransaction?.rapport
                                                    ?.identifiant ?? 'N/A'
                                            }}]</span
                                        >
                                    </span>
                                </strong>
                            </h4>
                        </div>
                        <div class="wrapper-header" style="font-size: 20px">
                            Statut :&nbsp;<b
                                ><span>{{ detailTransaction?.statut }}</span></b
                            >
                        </div>
                        <div class="wrapper-header" style="font-size: 20px">
                            Date de traitement :&nbsp;<b
                                ><span>{{ IscurrentDate() ?? 'N/A' }}</span></b
                            >
                        </div>
                    </div>
                    <hr
                        style="
                            position: relative;
                            top: -0.2rem;
                            margin-top: -0.8rem;
                        "
                    />
                    <!--------------LIGNE----------CREDIT------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === operationLigneCredit"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="ligneForm"
                        >
                            <fieldset>
                                <legend>
                                    <strong>Information de la ligne</strong>
                                </legend>
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>
                                                <b>Montant</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="montant"
                                                placeholder="montant"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>
                                                <b>Type Justificatif</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listTypeJustificatif"
                                                formControlName="type_justificatif"
                                                placeholder="Type"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label>
                                                <b>Description</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="description"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            style="margin-left: 8%"
                                            class="ml-3"
                                        >
                                            <span
                                                for="accepte"
                                                style="
                                                    font-size: 23px;
                                                    margin-left: 5%;
                                                    font-weight: 800;
                                                "
                                                >Accepté ?
                                            </span>
                                            <div class="wrapper-check">
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="provisionning_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="oui"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Oui</label
                                                    >
                                                </div>
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="provisionning_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="non"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Non</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="provisionning_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!--------------DEPOT----------VOLUME------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === OperationVolumeData"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="volumeForm"
                        >
                            <fieldset>
                                <legend>
                                    <b>Informations de la ligne</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>MSIDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="msisdn"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="imsi"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Statut Contrat</b>
                                            </label>
                                            <!-- <input type="text" formControlName="statut_contrat" pInputText /> -->
                                            <app-statut-contrat
                                                [statut]="
                                                    detailTransaction?.statut_contrat
                                                "
                                            ></app-statut-contrat>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b>Détails de la ligne</b>
                                </legend>
                                <div class="row">
                                    <!-- <div class="col-md-3">
                  <div style="display: flex;gap: 2rem;">
                    <div class="d-flex gap-2">
                      <p-radioButton name="bac_a_pioche" value="stock" formControlName="bac_a_pioche"
                        inputId="b_1"></p-radioButton>
                      <label style="margin-top: 0.9rem">Dotation Point Emplacement</label>
                    </div>
                  </div>
                </div> -->
                                    <div>
                                        <div class="form-group">
                                            <label style="opacity: 0">
                                                <b>
                                                    <span class="text-danger"
                                                        >*</span
                                                    ></b
                                                >
                                            </label>
                                            <input
                                                [disabled]="true"
                                                class="infos_text"
                                                [value]="
                                                    sourceStock === 'stock'
                                                        ? sourceSoldeDotation
                                                        : sourceSoldeDotationOrange
                                                "
                                                type="text"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b
                                                    >Voume (Go)<span
                                                        class="text-danger"
                                                        >*</span
                                                    ></b
                                                >
                                            </label>
                                            <input
                                                type="number"
                                                formControlName="volume"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="form-group">
                                            <label>
                                                <b
                                                    >Description<span
                                                        class="text-danger"
                                                        >*</span
                                                    ></b
                                                >
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="description"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            style="margin-left: 8%"
                                            class="ml-3"
                                        >
                                            <span
                                                for="accepte"
                                                style="
                                                    font-size: 23px;
                                                    margin-left: 5%;
                                                    font-weight: 800;
                                                "
                                                >Accepté ?
                                            </span>
                                            <div class="wrapper-check">
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="volume_data_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="oui"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Oui</label
                                                    >
                                                </div>
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="volume_data_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="non"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Non</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="volume_data_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!--------------CHANGEMENT------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === operationSwap"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="swapForm"
                        >
                            <fieldset>
                                <legend>
                                    <b>Informations sur la SIM</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>MSIDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="msisdn"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="imsi"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Statut Contrat</b>
                                            </label>
                                            <app-statut-contrat
                                                [statut]="
                                                    detailTransaction?.statut_contrat
                                                "
                                            ></app-statut-contrat>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b
                                        >Source Stock SIM / Détails de la
                                        ligne</b
                                    >
                                </legend>
                                <!-- <div class="d-flex gap-4">
                                    <div>
                                        <div class="d-flex gap-4">
                                            <div
                                                class="trans-radio d-flex gap-2"
                                            >
                                                <p-radioButton
                                                    name="valeur"
                                                    [value]="'stock'"
                                                    formControlName="bac_a_pioche"
                                                    [inputId]="'stock'"
                                                ></p-radioButton>
                                                <label
                                                    [for]="'stock'"
                                                    style="margin-top: 0.9rem"
                                                    >Stock SIM/Tenant</label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="d-flex gap-4">
                                            <div
                                                class="trans-radio d-flex gap-2"
                                            >
                                                <p-radioButton
                                                    name="valeur"
                                                    [value]="'orangeci'"
                                                    formControlName="bac_a_pioche"
                                                    [inputId]="'orangeci'"
                                                ></p-radioButton>
                                                <label
                                                    [for]="'orangeci'"
                                                    style="margin-top: 0.9rem"
                                                    >Stock SIM/OCI</label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-wrapper mt-2">
                                    <input
                                        [value]="
                                            sourceStockSwap === 'stock'
                                                ? sourceStockTenantSim
                                                : sourceStockOrangeSim
                                        "
                                        type="text"
                                        [disabled]="true"
                                        pInputText
                                    />
                                </div> -->
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>
                                                <b
                                                    >Description<span
                                                        class="text-danger"
                                                        >*</span
                                                    ></b
                                                >
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="description"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            style="margin-left: 8%"
                                            class="ml-3"
                                        >
                                            <span
                                                for="accepte"
                                                style="
                                                    font-size: 23px;
                                                    margin-left: 5%;
                                                    font-weight: 800;
                                                "
                                                >Accepté ?
                                            </span>
                                            <div class="wrapper-check">
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="swap_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="oui"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Oui</label
                                                    >
                                                </div>
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="swap_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="non"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Non</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="swap_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!--------------RESILIATION------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === OperationResiliation"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="resiliationForm"
                        >
                            <fieldset>
                                <legend>
                                    <b>Informations sur la SIM</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>MSIDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="msisdn"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="imsi"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Statut Contrat</b>
                                            </label>
                                            <app-statut-contrat
                                                [statut]="
                                                    this.detailTransaction
                                                        ?.statut_contrat
                                                "
                                            ></app-statut-contrat>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b>Détails de la ligne</b>
                                </legend>
                                <div class="row">
                                    <div class="form-group">
                                        <label>
                                            <b
                                                >Description<span
                                                    class="text-danger"
                                                    >*</span
                                                ></b
                                            >
                                        </label>
                                        <input
                                            type="text"
                                            formControlName="description"
                                            pInputText
                                        />
                                    </div>
                                </div>
                                <br />
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            class="wrapper-check"
                                            style="
                                                display: flex;
                                                justify-content: center !important;
                                                padding-top: 1.3rem;
                                            "
                                        >
                                            <div
                                                class="form-check form-check-inline"
                                            >
                                                <span
                                                    class="badge table-header-wrapper"
                                                    [class.badge-danger]="
                                                        IsTraitement() ===
                                                        treatmenRejeter
                                                    "
                                                    [class.badge-success]="
                                                        IsTraitement() ===
                                                        treatmenAccepter
                                                    "
                                                >
                                                    {{ IsTraitement() }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="resiliation_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!--------------SUSPENSION------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === OperationSuspension"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="suspensionForm"
                        >
                            <fieldset>
                                <legend>
                                    <b>Informations sur la SIM</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>MSIDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="msisdn"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="imsi"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Statut Contrat</b>
                                            </label>
                                            <app-statut-contrat
                                                [statut]="
                                                    detailTransaction?.statut_contrat
                                                "
                                            ></app-statut-contrat>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b>Détails de la ligne</b>
                                </legend>
                                <div class="row">
                                    <div class="form-group">
                                        <label>
                                            <b
                                                >Description<span
                                                    class="text-danger"
                                                    >*</span
                                                ></b
                                            >
                                        </label>
                                        <input
                                            type="text"
                                            formControlName="description"
                                            pInputText
                                        />
                                    </div>
                                </div>
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            class="wrapper-check"
                                            style="
                                                display: flex;
                                                justify-content: center !important;
                                                padding-top: 1.3rem;
                                            "
                                        >
                                            <div
                                                class="form-check form-check-inline"
                                            >
                                                <span
                                                    class="badge table-header-wrapper"
                                                    [class.badge-danger]="
                                                        IsTraitement() ===
                                                        treatmenRejeter
                                                    "
                                                    [class.badge-success]="
                                                        IsTraitement() ===
                                                        treatmenAccepter
                                                    "
                                                >
                                                    {{ IsTraitement() }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="suspension_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!--------------FORMULE------------FORMS----------------->
                    <div
                        *ngIf="transaction?.operation === OperationFormule"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="formuleForm"
                        >
                            <fieldset>
                                <legend>
                                    <b>Informations sur la SIM</b>
                                </legend>
                                <div class="wrapper-sim-infos">
                                    <div>
                                        <div class="form-group">
                                            <label>
                                                <b>MSIDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="msisdn"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="imsi"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group">
                                            <label>
                                                <b>Formule</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="formule"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group">
                                            <label>
                                                <b>Statut Contrat</b>
                                            </label>
                                            <app-statut-contrat
                                                [statut]="
                                                    detailTransaction?.statut_contrat
                                                "
                                            ></app-statut-contrat>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b>Détails Formule</b>
                                </legend>
                                <div class="row">
                                    <div class="form-group">
                                        <label>
                                            <b
                                                >Formule de destination<span
                                                    class="text-danger"
                                                    >*</span
                                                ></b
                                            >
                                        </label>
                                        <p-dropdown
                                            [options]="listFormules"
                                            formControlName="formule_uuid"
                                            optionLabel="nom"
                                            [showClear]="true"
                                            optionValue="uuid"
                                        >
                                            <ng-template
                                                let-data
                                                pTemplate="item"
                                            >
                                                <div class="country-item">
                                                    <div>
                                                        {{ data.nom }}
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset>
                                <legend>
                                    <b>Détails de la ligne</b>
                                </legend>
                                <div class="row">
                                    <div class="form-group">
                                        <label>
                                            <b
                                                >Description<span
                                                    class="text-danger"
                                                    >*</span
                                                ></b
                                            >
                                        </label>
                                        <input
                                            type="text"
                                            formControlName="description"
                                            pInputText
                                        />
                                    </div>
                                </div>
                                <br />
                                <div class="justificatif-container">
                                    <div *ngIf="IsJustificatif()">
                                        <button
                                            pButton
                                            pRipple
                                            label="Télécharger le justificatif"
                                            icon="pi pi-download"
                                            class="p-button-success"
                                            (click)="downloadFile()"
                                        ></button>
                                    </div>
                                    <div class="justificatif-error">
                                        <span class="" *ngIf="!IsJustificatif()"
                                            ><b class="disabled-piece-jointe"
                                                >Aucune pièce jointe</b
                                            ></span
                                        >
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            class="wrapper-check"
                                            style="
                                                display: flex;
                                                justify-content: center !important;
                                                padding-top: 1.3rem;
                                            "
                                        >
                                            <div
                                                class="form-check form-check-inline"
                                            >
                                                <span
                                                    class="badge table-header-wrapper"
                                                    [class.badge-danger]="
                                                        IsTraitement() ===
                                                        treatmenRejeter
                                                    "
                                                    [class.badge-success]="
                                                        IsTraitement() ===
                                                        treatmenAccepter
                                                    "
                                                >
                                                    {{ IsTraitement() }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="chg_formule_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!-------------ACTIVATION--------------FORMS--------------------------->
                    <div
                        *ngIf="transaction?.operation === operationActivation"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="activationForm"
                        >
                            <div [style]="{ marginTop: '-2rem' }">
                                <div class="row">
                                    <!-- <div class="col-md-3">
                                        <fieldset
                                            *ngIf="
                                                bacPiocheActivation !==
                                                'patrimoine'
                                            "
                                            style="padding-bottom: 1.2rem"
                                        >
                                            <legend>
                                                <b>Source Stock SIM</b>
                                            </legend>
                                            <div
                                                class="d-flex gap-2"
                                                style="
                                                    padding-top: 1.4rem !important;
                                                "
                                            >
                                                <div
                                                    [style]="{ width: '100%' }"
                                                >
                                                    <div class="form-group">
                                                        <label
                                                            for=""
                                                            style="opacity: 0"
                                                            >test</label
                                                        >
                                                        <input
                                                            [value]="
                                                                truncateText(
                                                                    bacPiocheActivation ===
                                                                        'stock'
                                                                        ? sourceStockTenantSim
                                                                        : sourceStockOrangeSim,
                                                                    50
                                                                )
                                                            "
                                                            type="text"
                                                            style="
                                                                font-size: 13.5px !important;
                                                                font-weight: bold !important;
                                                            "
                                                            [disabled]="true"
                                                            pInputText
                                                            pTooltip="{{
                                                                bacPiocheActivation ===
                                                                'stock'
                                                                    ? sourceStockTenantSim
                                                                    : sourceStockOrangeSim
                                                            }}"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div> -->

                                    <div class="col-md-12">
                                        <fieldset>
                                            <legend>
                                                <b>Informations SIM</b>
                                            </legend>
                                            <div
                                                class="row"
                                                style="
                                                    padding-top: 1.4rem !important;
                                                "
                                            >
                                                <div class="col-md">
                                                    <div class="form-group">
                                                        <label>
                                                            <b>MSISDN</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            formControlName="msisdn"
                                                            pInputText
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-md">
                                                    <div class="form-group">
                                                        <label>
                                                            <b>IMSI</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            formControlName="imsi"
                                                            pInputText
                                                        />
                                                    </div>
                                                </div>
                                                <div class="col-md">
                                                    <label><b>ICCID</b></label>
                                                    <input
                                                        type="text"
                                                        formControlName="iccid"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label><b>APN</b></label>
                                                    <input
                                                        type="text"
                                                        formControlName="apn"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label
                                                        ><b
                                                            >Adresse IP</b
                                                        ></label
                                                    >
                                                    <input
                                                        type="text"
                                                        formControlName="adresse_ip"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label
                                                        ><b
                                                            >Formule
                                                            destination</b
                                                        ></label
                                                    >
                                                    <input
                                                        type="text"
                                                        formControlName="formule"
                                                        pInputText
                                                    />
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <fieldset>
                                <legend>
                                    <b>Informations d'affectation</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>{{ firstLevelLibelle }}</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listFirstLevel"
                                                formControlName="niveau_un_uuid"
                                                optionLabel="nom"
                                                optionValue="uuid"
                                                [filter]="true"
                                                filterBy="nom"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom }} [{{
                                                                data.code
                                                            }}]
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>{{ secondLevelLibelle }}</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listSecondLevel"
                                                formControlName="niveau_deux_uuid"
                                                optionLabel="nom"
                                                optionValue="uuid"
                                                [filter]="true"
                                                filterBy="nom"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>{{ thirdLevelLibelle }}</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listThirdLevel"
                                                formControlName="niveau_trois_uuid"
                                                optionLabel="nom"
                                                optionValue="uuid"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Usage</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listUsages"
                                                formControlName="usage_id"
                                                optionLabel="nom_usage"
                                                placeholder="Usage"
                                                optionValue="id"
                                                placeholder="Usage"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom_usage }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Adresse mail</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="adresse_email"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Adresse géographique</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="adresse_geographique"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Latitude</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="latitude"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Longitude</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="longitude"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div
                        *ngIf="transaction?.operation === OperationAchat"
                        class="form-container"
                    >
                        <div [hidden]="filterTab !== 'first-item'">
                            <fieldset>
                                <legend>
                                    <strong>Information de la ligne</strong>
                                </legend>
                                <div
                                    class="panier-card"
                                    *ngFor="
                                        let prod of detailTransaction?.detail_commande
                                    "
                                >
                                    <div class="panier-card__file">
                                        <img
                                            src="assets/images/unboxing.png"
                                            alt=""
                                        />
                                    </div>
                                    <div class="panier-card__infos">
                                        <div class="panier-card__infos--code">
                                            {{ prod.code_produit }}
                                        </div>
                                        <div class="panier-card__infos--nom">
                                            {{ prod.nom_produit }}
                                        </div>
                                    </div>
                                    <div class="panier-card__quantity">
                                        <span>{{ prod.quantite }}</span>
                                    </div>
                                    <div class="panier-card__price">
                                        {{
                                            pipeValue(
                                                prod.montant_ht * prod.quantite
                                            )
                                        }}
                                        F
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset *ngIf="ShowAcceptedForm()">
                                <legend>
                                    <strong>Traitement</strong>
                                </legend>
                                <div
                                    class="wrapper-evaluation"
                                    style="display: flex; gap: 1rem"
                                >
                                    <div class="block-checked">
                                        <div
                                            style="margin-left: 8%"
                                            class="ml-3"
                                        >
                                            <span
                                                for="accepte"
                                                style="
                                                    font-size: 23px;
                                                    margin-left: 5%;
                                                    font-weight: 800;
                                                "
                                                >Accepté ?
                                            </span>
                                            <div class="wrapper-check">
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="commmande_produit_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="oui"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Oui</label
                                                    >
                                                </div>
                                                <div
                                                    class="form-check form-check-inline"
                                                >
                                                    <input
                                                        formControlName="commmande_produit_accepte"
                                                        class="form-check-input"
                                                        type="radio"
                                                        name="infosLigne"
                                                        value="non"
                                                        id="infosLigne"
                                                    />
                                                    <label
                                                        class="form-check-label"
                                                        for="infosLigne"
                                                        style="
                                                            width: auto !important;
                                                        "
                                                        >Non</label
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 100%">
                                        <label for="commentaire"
                                            ><strong>Commentaire</strong></label
                                        >
                                        <textarea
                                            name="commentaire"
                                            formControlName="commmande_produit_accepte_comment"
                                            class="form-control"
                                            rows="2"
                                            style="width: 100%; margin-top: 0%"
                                            placeholder="Entrer un commentaire"
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <!------------INTEGRATION-------------FORMS------------------->

                    <div
                        *ngIf="transaction?.operation === operationIntegration"
                        class="form-container"
                    >
                        <div
                            [hidden]="filterTab !== 'first-item'"
                            [formGroup]="integrationForm"
                        >
                            <div [style]="{ marginTop: '-2rem' }">
                                <div class="row">
                                    <div class="col-md-12">
                                        <fieldset>
                                            <legend>
                                                <b>Informations SIM</b>
                                            </legend>
                                            <div
                                                class="row"
                                                style="
                                                    padding-top: 1.4rem !important;
                                                "
                                            >
                                                <div class="col-md">
                                                    <label><b>MSISDN</b></label>
                                                    <input
                                                        type="text"
                                                        formControlName="msisdn"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label><b>IMSI</b></label>
                                                    <input
                                                        type="text"
                                                        formControlName="imsi"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label><b>ICCID</b></label>
                                                    <input
                                                        type="text"
                                                        formControlName="iccid"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label
                                                        ><b
                                                            >Formule
                                                            destination</b
                                                        ></label
                                                    >
                                                    <input
                                                        type="text"
                                                        formControlName="formule"
                                                        pInputText
                                                    />
                                                </div>
                                                <div class="col-md">
                                                    <label
                                                        ><b
                                                            >Montant de la
                                                            formule/SIM</b
                                                        ></label
                                                    >
                                                    <input
                                                        type="text"
                                                        formControlName="montant_formule"
                                                        pInputText
                                                    />
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <fieldset>
                                <legend>
                                    <b>Informations d'affectation</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label
                                                ><b>{{
                                                    firstLevelLibelle
                                                }}</b></label
                                            >
                                            <p-dropdown
                                                [options]="listFirstLevel"
                                                optionLabel="fullName"
                                                (onChange)="
                                                    onChangeFirstLvel(
                                                        $event.value
                                                    )
                                                "
                                                [showClear]="true"
                                                [filter]="true"
                                                filterBy="fullName"
                                                [placeholder]="
                                                    firstLevelLibelle
                                                "
                                                optionValue="uuid"
                                                formControlName="niveau_un_uuid"
                                                [ngStyle]="{ width: '100%' }"
                                            >
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>{{ secondLevelLibelle }}</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listSecondLevel"
                                                optionLabel="fullName"
                                                [filter]="true"
                                                [showClear]="true"
                                                formControlName="niveau_deux_uuid"
                                                [placeholder]="
                                                    firstLevelLibelle
                                                "
                                                optionValue="uuid"
                                                [ngStyle]="{ width: '100%' }"
                                            >
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>{{ thirdLevelLibelle }}</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listThirdLevel"
                                                formControlName="niveau_trois_uuid"
                                                optionLabel="nom"
                                                optionValue="uuid"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>
                                                <b>Usage</b>
                                            </label>
                                            <p-dropdown
                                                [options]="listUsages"
                                                formControlName="usage_id"
                                                optionLabel="nom_usage"
                                                placeholder="Usage"
                                                optionValue="id"
                                                placeholder="Usage"
                                            >
                                                <ng-template
                                                    let-data
                                                    pTemplate="item"
                                                >
                                                    <div class="country-item">
                                                        <div>
                                                            {{ data.nom_usage }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="row">
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Emplacement</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="point_emplacement"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Adresse mail</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="adresse_email"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Adresse géographique</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="adresse_geographique"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Latitude</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="latitude"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Longitude</b>
                                            </label>
                                            <input
                                                type="text"
                                                formControlName="longitude"
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <!-----------------------COMMENTAIRE----------CLOTURE--------------------------------->
                    <fieldset
                        *ngIf="
                            detailTransaction?.rapport?.statut_traitement &&
                            detailTransaction?.rapport?.statut_cloture
                        "
                    >
                        <legend>
                            <strong>Clôture</strong>
                        </legend>
                        <div
                            class="wrapper-evaluation"
                            style="display: flex; gap: 1rem"
                        >
                            <div class="block-checked">
                                <div>
                                    <div class="d-flex justify-content-center">
                                        <span
                                            for="accepte"
                                            style="
                                                font-size: 23px;
                                                font-weight: 800;
                                            "
                                            >Avis</span
                                        >
                                    </div>
                                    <div
                                        class="wrapper-check d-flex justify-content-center"
                                    >
                                        <img
                                            [src]="
                                                mappingNotation(
                                                    this.detailTransaction
                                                        ?.rapport
                                                        ?.notation_cloture
                                                )
                                            "
                                            width="30"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%">
                                <label for="commentaire"
                                    ><strong>Commentaire</strong></label
                                >
                                <input
                                    type="text"
                                    [disabled]="true"
                                    [value]="
                                        detailTransaction?.rapport
                                            ?.notation_description
                                    "
                                    pInputText
                                />
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>
